import React from "react";
import { FlaskConical, Coins } from "lucide-react";

export const MicrobiomeUpload = ({ extracting, labRef, extractReport, credits, buyCredits, buyingCredits }) => (
  <>
    <div className="mt-8 bg-[#2D322B] text-[#F9F6F0] rounded-3xl p-6 flex flex-col md:flex-row md:items-center gap-4" data-testid="microbiome-upload-bar">
      <div className="flex-1">
        <p className="label-eyebrow !text-[#D49A44]">Read your inner garden</p>
        <p className="font-serif text-xl mt-1">Upload your Bioscreen FMA report.</p>
        <p className="text-xs text-[#F9F6F0]/70 mt-1">
          Massey&apos;s vision reads your Faecal Microbial Analysis — culturing every commensal organism, its count and reference range — then maps your gut terrain. PDF or image, up to 25 MB.
        </p>
      </div>
      <div className="flex flex-wrap gap-3 items-center">
        <label className="btn-primary !bg-[#D49A44] !text-[#2D322B] hover:!bg-[#bf8a3a] inline-flex items-center gap-2 cursor-pointer" data-testid="microbiome-upload-label">
          <FlaskConical className="w-4 h-4" />
          {extracting ? "Reading report…" : "Upload Bioscreen FMA"}
          <input ref={labRef} type="file" accept=".pdf,.png,.jpg,.jpeg,.webp,.heic" onChange={extractReport} className="hidden" data-testid="microbiome-upload-input" disabled={extracting} />
        </label>
      </div>
    </div>

    {credits && (
      <div className="mt-3 px-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-[#5C6359]" data-testid="microbiome-credits-bar">
        <p>
          <span className="text-[#D49A44] font-medium">{credits.total_available}</span> extraction credit{credits.total_available === 1 ? "" : "s"} available
          {credits.monthly_quota > 0 && <> · {credits.monthly_remaining}/{credits.monthly_quota} this month</>}
          <span className="mx-2 text-[#D1C7B8]">·</span>
          <span>1 credit per report</span>
        </p>
        <button onClick={buyCredits} disabled={buyingCredits} data-testid="microbiome-buy-credits-btn"
          className="inline-flex items-center gap-1 text-[#C05C42] hover:text-[#2D322B] uppercase tracking-widest disabled:opacity-60">
          <Coins className="w-3.5 h-3.5" />
          {buyingCredits ? "Opening…" : (credits.pack ? `Buy ${credits.pack.credits} for $${credits.pack.amount_usd}` : "Buy credits")}
        </button>
      </div>
    )}
  </>
);
